module.exports = __webpack_public_path__ + "img/air-freight.a51ade72.svg";